export const DEFAULT_PROJECT_LIST_SORT = {
  sortByColumn: "starred",
  orderBy: "desc",
};
